export const OWNER = Object.freeze({
  APPLICATION : null,
  TENANT      : 'tenant',
  IES         : 'ies'
});
